import {createFileRoute, redirect} from '@tanstack/react-router';

import {Route as RouteEnum} from '~utils/routeUtil';

export const Route = createFileRoute('/model/statistics/')({
  beforeLoad: async () => {
    // Redirect to label distribution page
    throw redirect({
      to: RouteEnum.modelLabelDistribution as any,
    });
  },
});
